import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { FloApiResponse } from '../shared/models/api-response.model'
import { Result } from '../shared/models/result.model'
import { EXPERIENCE_API_LEGACY_CORE_RESULTS_PATH, EXPERIENCE_API_VERSION } from '../app.config'

@Injectable()
export class ResultsService {
  public result$: Observable<FloApiResponse<Result>>

  constructor(private readonly http: HttpClient) {}

  public getResult(id: number) {
    this.result$ = this.http.get<FloApiResponse<Result>>(`${EXPERIENCE_API_LEGACY_CORE_RESULTS_PATH}/${id}`, {
      params: {
        version: EXPERIENCE_API_VERSION
      }
    })
    return this.result$
  }
}
